/*
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-09 20:04:57
 * @LastEditTime: 2026-04-10 11:46:57
 * @LastEditors: ranli
 */
import { defineStore } from 'pinia'
import { getUserInfo, getBalance, thirdLogin } from '@/api/index.js'
import { notifyBalanceChange } from '@/utils/index.js'
export const useStore = defineStore('CRICKET', {
  persist: {
    paths: ['userInfo'],
  },
  state: () => ({
    userInfo: {},
    plateform: {},
    params: {},
  }),
  getters: {
    P_PARAMS(state) {
      return state.plateform
    },
    USERINFO(state) {
      return state.userInfo
    },
    // 用户余额
    USER_BALANCE(state) {
      return state.userInfo?.balance || 0
    },
  },
  actions: {
    // 设置用户
    async GET_USERINFO() {
      // await thirdLogin();
      // return null;
      this.userInfo = {}
      const uinfo = await getUserInfo();
      this.userInfo = uinfo.resultData
      return uinfo
    },

    async REFRESH_BALANCE() {
      const res = await getBalance()
      const balance = res?.resultData?.balance || 0
      this.userInfo.balance = balance
      notifyBalanceChange(balance);
      return balance
    },
    // 设置平台信息
    SET_P_D(info) {
      this.plateform = info
    },
    //设置sign 和 uid 必要参数
    SET_PARAMS(info) {
      this.params = info

    },
  },
})
